module.exports = __webpack_public_path__ + "img/4.03.thmb.9f5cef26.jpg";